//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import template from 'showroom-settings-customize-media.html';

export class ShowroomSettingsCustomizeMedia {
  public STATES;
  public itemId: string;
  public trackingCategory: string;
  public trackingAction: string;
  public trackingLabels;

    // Bound fields
  public onUpdateCuratedMediaState;

  constructor(
        private ShowroomApiService,
        private ShowroomService,
        private TrackingService,
        private SHOWROOM_CURATION_STATES,
    ) { }

  public updateCuratedMediaState = (newValue) => {
    this.TrackingService.recordEvent(
            this.trackingCategory,
            this.trackingAction,
            this.trackingLabels.RELATED_MEDIA_UPDATED(newValue),
        );
    this.onUpdateCuratedMediaState(newValue);
  }

  public $onInit() {
    this.STATES = this.SHOWROOM_CURATION_STATES;
    this.trackingCategory = this.ShowroomService.getTrackingCategory();
    this.trackingAction = this.ShowroomService.getTrackingAction();
    this.trackingLabels = {
      RELATED_MEDIA_UPDATED: (state) => `SetRelatedMedia=${state}`,
    };
  }
}

angular.module('uia').component('showroomSettingsCustomizeMedia', {
  bindings: {
    hasProductCatalog: '<',
    numMediaRecommendations: '<',
    itemId: '<',
    startingLabels: '<',
    onLabelsUpdated: '<',
    useCuratedRecommendations: '<',
    onUpdateCuratedMediaState: '<',
    curatedMediaState: '<',
  },
  template,
  controller: [
    'ShowroomApiService',
    'ShowroomService',
    'TrackingService',
    'SHOWROOM_CURATION_STATES',
    ShowroomSettingsCustomizeMedia,
  ],
});
